import React from 'react';
import * as Styled from './CollectionsSkeleton.styles';

export const CollectionsSkeleton = () => {
  return (
    <Styled.Wrapper>
      <Styled.Header>
        <Styled.CategoryFilter>
          <Styled.CategoryFilterItem />
          <Styled.CategoryFilterItem />
          <Styled.CategoryFilterItem />
          <Styled.CategoryFilterItem />
        </Styled.CategoryFilter>
        <Styled.CategoryFilterItem />
      </Styled.Header>

      <Styled.CollectionsList>
        <Styled.CollectionCarousel isFeatured>
          <Styled.CollectionCarouselHeader>
            <Styled.CollectionCarouselTitle />
            <Styled.CollectionCarouselLink />
          </Styled.CollectionCarouselHeader>
          <Styled.CollectionCarouselImages>
            <Styled.CollectionCarouselImage />
            <Styled.CollectionCarouselImage />
            <Styled.CollectionCarouselImage />
            <Styled.CollectionCarouselImage />
          </Styled.CollectionCarouselImages>
        </Styled.CollectionCarousel>

        <Styled.CollectionCarousel>
          <Styled.CollectionCarouselHeader>
            <Styled.CollectionCarouselTitle />
            <Styled.CollectionCarouselLink />
          </Styled.CollectionCarouselHeader>
          <Styled.CollectionCarouselImages>
            <Styled.CollectionCarouselImage />
            <Styled.CollectionCarouselImage />
            <Styled.CollectionCarouselImage />
            <Styled.CollectionCarouselImage />
          </Styled.CollectionCarouselImages>
        </Styled.CollectionCarousel>
      </Styled.CollectionsList>
    </Styled.Wrapper>
  );
};
